function _2digitsNumber(value) {
  return Number(value.toFixed(2));
}

export default {
  /**
   * Based on https://www.thecalculatorsite.com/articles/finance/compound-interest-formula.php
   * @param principal how much money did we start with?
   * @param monthlyAddition how much money is added every month?
   * @param interest what's the interest rate?
   * @param years how many years to take into account?
   * @returns {number}
   */
  compoundInterest(principal, monthlyAddition, interest, years) {
    const compoundInterestOfPrincipal = this.compoundInterestOfPrincipal(principal, interest, years);
    const futureValueOfSeries = this.futureValueOfSeries(monthlyAddition, interest, years);
    return compoundInterestOfPrincipal + futureValueOfSeries;
  },
  compoundInterestOfPrincipal(principal, interest, years) {
    return _2digitsNumber(principal * ((1 + interest / 12) ** (12 * years)));
  },
  futureValueOfSeries(monthlyAddition, interest, years) {
    return _2digitsNumber(monthlyAddition * ((((1 + interest / 12) ** (12 * years)) - 1) / (interest / 12)) * (1 + interest / 12));
  },
};
